module.exports = __webpack_public_path__ + "static/img/pointer-begin.60f2031.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pointer-begin.png
// module id = iJgw
// module chunks = 1